import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Users, DollarSign, Zap } from 'lucide-react';
interface InvestorSlide5Props {
  isDark?: boolean;
}
export function InvestorSlide5({
  isDark = false
}: InvestorSlide5Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 20
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-285">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-286">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-287">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-288">
            Why Now
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-289">
            The market has reached a tipping point for leadership wellness.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-12" data-id="element-290">
          {/* Stat 1 */}
          <motion.div variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 flex flex-col items-center text-center ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige shadow-sm'}`} data-id="element-291">
            <div className="w-16 h-16 rounded-full bg-heliona-mint/20 flex items-center justify-center mb-6" data-id="element-292">
              <Users className="w-8 h-8 text-heliona-mint-dark" data-id="element-293" />
            </div>
            <div className={`text-5xl sm:text-6xl font-bold mb-4 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-294">
              76%
            </div>
            <p className={`text-base sm:text-lg font-medium mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-295">
              Employee Expectation
            </p>
            <p className={`text-sm sm:text-base ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-296">
              of employees expect employers to support mental health (McKinsey)
            </p>
          </motion.div>

          {/* Stat 2 */}
          <motion.div variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 flex flex-col items-center text-center ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige shadow-sm'}`} data-id="element-297">
            <div className="w-16 h-16 rounded-full bg-heliona-orange/20 flex items-center justify-center mb-6" data-id="element-298">
              <DollarSign className="w-8 h-8 text-heliona-orange" data-id="element-299" />
            </div>
            <div className={`text-5xl sm:text-6xl font-bold mb-4 ${isDark ? 'text-heliona-orange' : 'text-heliona-orange'}`} data-id="element-300">
              $125B
            </div>
            <p className={`text-base sm:text-lg font-medium mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-301">
              Annual Cost
            </p>
            <p className={`text-sm sm:text-base ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-302">
              of leadership burnout in healthcare spending alone
            </p>
          </motion.div>

          {/* Stat 3 */}
          <motion.div variants={itemVariants} className={`rounded-3xl p-8 sm:p-10 flex flex-col items-center text-center ${isDark ? 'bg-white/[0.03] border border-white/10' : 'bg-white border border-heliona-beige shadow-sm'}`} data-id="element-303">
            <div className="w-16 h-16 rounded-full bg-heliona-navy/20 flex items-center justify-center mb-6" data-id="element-304">
              <Zap className="w-8 h-8 text-heliona-navy" data-id="element-305" />
            </div>
            <div className={`text-5xl sm:text-6xl font-bold mb-4 ${isDark ? 'text-white' : 'text-heliona-navy'}`} data-id="element-306">
              Gen Z
            </div>
            <p className={`text-base sm:text-lg font-medium mb-2 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-307">
              New Standard
            </p>
            <p className={`text-sm sm:text-base ${isDark ? 'text-white/70' : 'text-heliona-text-gray'}`} data-id="element-308">
              Next-gen leaders expect wellness as a standard benefit, not a perk
            </p>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}